module.exports = __webpack_public_path__ + "static/img/t41.fb886e72.png";